// extracted by mini-css-extract-plugin
export var bodySections = "_ci-8";
export var gray = "_ci-7";
export var green = "_ci-4";
export var iconContainer = "_ci-9";
export var iconWidgetContainer = "_ci-1";
export var phoneIcon = "_ci-2";
export var red = "_ci-5";
export var statusDot = "_ci-3";
export var widgetContainer = "_ci-0";
export var yellow = "_ci-6";